import React, { useEffect, useRef } from 'react';
import QRCode from 'qrcode';
import '../App.css';
import html2canvas from 'html2canvas';

const Tarjeta = ({ nombreTitular, numeroTarjeta, cvv, contactoTitular }) => {
    const qrRef = useRef(null);
    const cardRef = useRef(null);

   
    useEffect(() => {
        const qrData = `https://192.168.0.194:3000/search?nombre=${encodeURIComponent(nombreTitular)}&numero=${encodeURIComponent(numeroTarjeta)}&cvv=${encodeURIComponent(cvv)}&contacto=${encodeURIComponent(contactoTitular)}`;
        QRCode.toCanvas(qrRef.current, qrData, { width: 100 }, (error) => {
            if (error) console.error('Error generating QR code:', error);
        });
    }, [nombreTitular, numeroTarjeta, cvv, contactoTitular]);

    const handleDownload = () => {
        const card = cardRef.current;

        html2canvas(card).then((canvas) => {
            const link = document.createElement('a');
            link.download = `Tajeta ${nombreTitular}.jpg`;
            link.href = canvas.toDataURL('image/jpeg');
            link.click();
        }).catch((error) => {
            console.error('Error generando imagen:', error);
        });
    };

    return (
        <div>
            <div className="credit-card" ref={cardRef}>
                <div className="credit-card__content">
                    <div className="credit-card__number">
                        {numeroTarjeta.replace(/(.{4})/g, '$1 ')}
                    </div>
                    <div className="credit-card__info">
                    <canvas ref={qrRef} className="credit-card__qr"></canvas>
                   
                        <div className="credit-card__name">{nombreTitular}</div>
                        <div className="credit-card__cvv">CVV: {cvv}</div>
                        <div className='info-card'>Obtén descuentos y promociones exclusivas con tu tarjeta cliente Fruve. El uso inadecuado de la tarjeta puede resultar en su bloqueo.</div>
                 </div>
                </div>
            </div>
            <button className='btn btn-success' onClick={handleDownload}>Descargar Tarjeta</button>
        </div>
    );
};

export default Tarjeta;
